import React, { useEffect } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import {
	Stack,
	CardContent,
	CircularProgress,
	Box,
	Typography,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell
} from '@mui/material';
import Card from 'components7/Card';
import utils from 'components/utils';

const DetailUserGroup = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const loading = useStoreState(state => state.kit.detail.loading);
	const kit = useStoreState(state => state.kit.detail.data);
	const numItems = kit.userGroups ? kit.userGroups.length : 0;
	const userGroups = kit.userGroups ? kit.userGroups.sort((a, b) => a.id - b.id) : [];
	const headCells = [
		{ id: 'id', label: 'kit.table.id', width: '80px', sortable: false },
		{ id: 'ean', label: 'kit.table.name', width: 'auto', sortable: false },
		{ id: 'type', label: 'kit.table.type', width: 'auto', sortable: false }
	];

	return (
		<Card backgroundColor="#fff" title={translate('kit.userGroups') + ' (' + numItems + ')'} width="100%">
			<CardContent sx={{ paddingBottom: '0' }}>
				{loading && (
					<Box sx={{ width: '100%', textAlign: 'center' }}>
						<CircularProgress size={32} sx={{ color: theme.palette.primary.main }} />
					</Box>
				)}
				{numItems == 0 && (
					<Box sx={{ width: '100%', textAlign: 'center' }}>
						<Typography variant="textTab" sx={{ fontWeight: '600' }}>
							{translate('kit.noUserGroups')}
						</Typography>
					</Box>
				)}
				{numItems > 0 && (
					<Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
						<Table aria-labelledby="items" aria-label="items table" padding="none">
							<TableHead>
								<TableRow>
									{headCells.map(headCell => (
										<TableCell
											key={headCell.id}
											align="left"
											sx={{
												background: theme.palette.custom.greytable,
												fontWeight: '600',
												width: headCell.width
											}}
										>
											{translate(headCell.label)}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{userGroups.map((row, index) => (
									<TableRow key={index}>
										<TableCell sx={{ padding: '10px 0' }}>
											<Typography variant="textTable">{row.id}</Typography>
										</TableCell>
										<TableCell>
											<Typography variant="textTable">{row.name}</Typography>
										</TableCell>
										<TableCell>
											<Typography variant="textTable">{row.type}</Typography>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Stack>
				)}
			</CardContent>
		</Card>
	);
};

export default DetailUserGroup;
